"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _VoucherStoreMap = require("../map/VoucherStoreMap");

var _VoucherStoreMap2 = _interopRequireDefault(_VoucherStoreMap);

var _VoucherOrderSelect = require("./VoucherOrderSelect");

var _VoucherOrderSelect2 = _interopRequireDefault(_VoucherOrderSelect);

var _VoucherOrderCart = require("./VoucherOrderCart");

var _VoucherOrderCart2 = _interopRequireDefault(_VoucherOrderCart);

var _VoucherOrderTypeSelect = require("./VoucherOrderTypeSelect");

var _VoucherOrderTypeSelect2 = _interopRequireDefault(_VoucherOrderTypeSelect);

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderForm = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderForm, _Component);

  function VoucherOrderForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherOrderForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherOrderForm.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderForm)).call.apply(_ref, [this].concat(args))), _this), _this.isFormDisabled = function () {
      return !_this.getOrderType() || !_this.getPlaces();
    }, _this.isOrderProcessing = function () {
      return !_this.props.query || !(0, _keys2.default)(_this.props.query);
    }, _this.getOrderType = function () {
      return _this.isOrderProcessing() ? _this.props.vouchers.orderType : _this.props.orderType;
    }, _this.getPlaces = function () {
      return _this.getOrderType() && _this.props.vouchers.places ? _this.props.vouchers.places : [];
    }, _this.getCart = function () {
      return _this.getOrderType() && _this.props.vouchers.cart ? _this.props.vouchers.cart : [];
    }, _this.isCartBlank = function () {
      return _this.getCart().length === 0;
    }, _this.addToCart = function (receiptPlace) {
      _this.props.insertCartItem(receiptPlace);
    }, _this.changeOrderType = function (orderType) {
      _this.props.changeOrderType(orderType);
      (0, _VoucherUtil.switchOrderType)({ orderType: orderType, pushRoute: _this.props.pushRoute });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherOrderForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          user = _props.user,
          orderType = _props.orderType;


      this.changeOrderType(orderType);

      if (user) {
        this.prefillUserData();
        this.prefillCompanyData();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.company && this.props.company) {
        this.prefillCompanyData();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          _props2$fields = _props2.fields,
          voucher = _props2$fields.voucher,
          business_id = _props2$fields.business_id,
          company_name = _props2$fields.company_name,
          first_name = _props2$fields.first_name,
          last_name = _props2$fields.last_name,
          address = _props2$fields.address,
          postal_code = _props2$fields.postal_code,
          city = _props2$fields.city,
          email = _props2$fields.email,
          phone = _props2$fields.phone,
          order_reference = _props2$fields.order_reference,
          handleSubmit = _props2.handleSubmit,
          onSubmit = _props2.onSubmit,
          removeCartItem = _props2.removeCartItem,
          updateQuantity = _props2.updateQuantity;


      return _react2.default.createElement(
        "form",
        { id: "voucherOrder", onSubmit: handleSubmit(onSubmit) },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "div",
              { className: "voucher-map-container" },
              _react2.default.createElement(
                "h2",
                { className: "h4 voucher-map-title" },
                "Paikat kartalla"
              ),
              _react2.default.createElement(_VoucherStoreMap2.default, { places: this.getPlaces() })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_VoucherOrderTypeSelect2.default, {
              fieldProps: {
                value: this.getOrderType(),
                onChange: function onChange(event) {
                  _this2.changeOrderType(event.target.value);
                }
              }
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_VoucherOrderSelect2.default, {
              orderType: this.getOrderType(),
              places: this.getPlaces(),
              fieldProps: voucher,
              handleInsertion: this.addToCart,
              disabled: this.isFormDisabled()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 voucher-order-car-container" },
            _react2.default.createElement(
              "h2",
              { className: "h4 form-title" },
              "Ostoskori:"
            ),
            _react2.default.createElement(_VoucherOrderCart2.default, {
              cart: this.getCart(),
              removeCartItem: removeCartItem,
              updateQuantity: updateQuantity,
              disabled: this.isFormDisabled()
            })
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Tilaajatiedot:"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "business_id",
              type: "text",
              label: "Y-tunnus",
              fieldProps: business_id,
              disabled: this.isFormDisabled()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "company_name",
              type: "text",
              label: "Yritys",
              fieldProps: company_name,
              disabled: this.isFormDisabled()
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "first_name",
              type: "text",
              label: "Etunimi",
              fieldProps: first_name,
              disabled: this.isFormDisabled()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "last_name",
              type: "text",
              label: "Sukunimi",
              fieldProps: last_name,
              disabled: this.isFormDisabled()
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "address",
              type: "text",
              label: "Katuosoite",
              fieldProps: address,
              disabled: this.isFormDisabled()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6 col-sm-3 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "postal_code",
              type: "text",
              label: "Postinumero",
              fieldProps: postal_code,
              disabled: this.isFormDisabled()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6 col-sm-3 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "city",
              type: "text",
              label: "Paikkakunta",
              fieldProps: city,
              disabled: this.isFormDisabled()
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "email",
              type: "email",
              label: "S\xE4hk\xF6posti",
              fieldProps: email,
              disabled: this.isFormDisabled()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "phone",
              type: "text",
              label: "Puhelinnumero",
              fieldProps: phone,
              disabled: this.isFormDisabled()
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(_Input2.default, {
              id: "order_reference",
              type: "text",
              label: "Tilausviite",
              fieldProps: order_reference,
              disabled: this.isFormDisabled()
            }),
            _react2.default.createElement(
              "p",
              null,
              "Onko sinulla lipukekauppaan sopiva projekti?",
              _react2.default.createElement("br", null),
              "Pyyda\u0308 ilmainen arvio numerosta",
              " ",
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              ),
              "."
            )
          )
        ),
        this.renderPaymentError(),
        _react2.default.createElement(_SubmitButton2.default, {
          text: "Tilaa",
          submitting: false,
          disabled: this.isCartBlank() || this.isFormDisabled()
        })
      );
    }
  }, {
    key: "prefillUserData",
    value: function prefillUserData() {
      var _props3 = this.props,
          _props3$fields = _props3.fields,
          first_name = _props3$fields.first_name,
          last_name = _props3$fields.last_name,
          phone = _props3$fields.phone,
          email = _props3$fields.email,
          address = _props3$fields.address,
          postal_code = _props3$fields.postal_code,
          city = _props3$fields.city,
          order_reference = _props3$fields.order_reference,
          user = _props3.user;


      first_name.onChange(user.first_name);
      last_name.onChange(user.last_name);
      phone.onChange(user.phone);
      email.onChange(user.email);
      order_reference.onChange(user.order_reference);

      if (!this.props.company && user.address) {
        address.onChange(user.address.street_address);
        postal_code.onChange(user.address.postal_code);
        city.onChange(user.address.postal_area);
      }
    }
  }, {
    key: "prefillCompanyData",
    value: function prefillCompanyData() {
      var company = this.props.company;

      if (company) {
        var _props$fields = this.props.fields,
            business_id = _props$fields.business_id,
            company_name = _props$fields.company_name,
            address = _props$fields.address,
            postal_code = _props$fields.postal_code,
            city = _props$fields.city;

        business_id.onChange(company.business_id);
        company_name.onChange(company.name);
        address.onChange(company.address.street_address);
        postal_code.onChange(company.address.postal_code);
        city.onChange(company.address.postal_area);
      }
    }
  }, {
    key: "renderPaymentError",
    value: function renderPaymentError() {
      if (this.props.paymentError) {
        return _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "p",
              { className: "error-message" },
              "Maksun aikana tapahtui virhe tai se keskeytettiin. Yrit\xE4 my\xF6hemmin uudelleen tai ota yhteytt\xE4 Maap\xF6rssiin."
            )
          )
        );
      }
    }
  }]);
  return VoucherOrderForm;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  orderType: _react.PropTypes.string,
  company: _react.PropTypes.object,
  insertCartItem: _react.PropTypes.func.isRequired,
  removeCartItem: _react.PropTypes.func.isRequired,
  updateQuantity: _react.PropTypes.func.isRequired,
  vouchers: _react.PropTypes.object.isRequired,
  paymentError: _react.PropTypes.bool.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.object
}, _temp2);
exports.default = VoucherOrderForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderForm.js
 ** module id = 487
 ** module chunks = 0
 **/